// extracted by mini-css-extract-plugin
export default {"reviewContainer":"reviewContainer-fyeao","reviewHeading":"reviewHeading-XpsEb","date":"date-qV4ce","comment":"comment-JGE3g","readMoreBtn":"readMoreBtn-T37Cy"};